import React from 'react';
import '../styles/style.css'

export class Urllink extends React.Component {
    url (link) {
        let outputlink = [];
        outputlink = link.split("?", 1);
        return outputlink[0];
    }
    render () {
        let inputlink = this.props.inlink;
        return ((
            <span>
                <a href={this.url(inputlink)} target="_blank" rel="noreferrer">{this.props.urlname}</a>
            </span>
        ));
    }
};